import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import dayjs from "dayjs";
import { DATE_FORMAT_FRONT } from "../../utils/constants";
import { Button } from "@mui/base";
import { useState } from "react";

function InvoiceNameRenderer(params) {
  return (
    <span className="my-renderer">
      <Link
        to={`/invoices/invoices/${params.data.invoice}`}
        style={{ textDecoration: "none" }}
      >
        {params.data?.po_id
          ? `PO# ${params.data.po_id}`
          : `# ${params.data.invoice}`}
      </Link>
    </span>
  );
}
export const commissionCols = (extrData) => [
  {
    headerName: "ID",
    field: "id",
    maxWidth: 80,
  },
  {
    headerName: "Invoice",
    field: "invoice",
    cellRendererSelector: () => {
      return {
        component: InvoiceNameRenderer,
      };
    },
    maxWidth: 120,
  },
  {
    headerName: "Account",
    field: "account.name",
    minWidth: 300,
  },
  {
    headerName: "date",
    field: "creation_date",
    cellRenderer: (params) => (
      <Typography>
        {dayjs.utc(params.data.creation_date).format(DATE_FORMAT_FRONT)}
      </Typography>
    ),
    maxWidth: 120,
  },
  {
    headerName: "Invoice Amount",
    field: "invoice_amount",
    cellRenderer: (params) => (
      <Typography>${params?.data?.invoice_amount}</Typography>
    ),
    maxWidth: 140,
  },
  {
    headerName: "Percentage",
    field: "percentage",
    cellRenderer: (params) => (
      <Typography>{params?.data?.percentage}%</Typography>
    ),
    maxWidth: 120,
  },
  {
    headerName: "Comission",
    field: "value",
    cellRenderer: (params) => <Typography>${params?.data?.value}</Typography>,
    maxWidth: 120,
  },
  {
    headerName: "Payout",
    field: "payout",
    cellRenderer: (params) => (
      <Typography>{params?.data?.payout ? "PAID" : "UNPAID"}</Typography>
    ),
    maxWidth: 140,
  },
  {
    headerName: "Details",
    cellRenderer: (params) => (
      <Button
        onClick={() => {
          extrData.setIsOpen(true);
          extrData.setCommissionData(params.data);
        }}
      >
        Show Details
      </Button>
    ),
  },
];

function CommissionDetailRowRenderer({ data }) {
  const [isOpen, setIsOpen] = useState(false);
  return <></>;
}
export function CommissionDetailsModal({ open, setOpen, data, setData }) {
  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
        setData({});
      }}
    >
      <DialogTitle>Commission {data?.id} Details</DialogTitle>
      <DialogContent>
        <table>
          <tr>
            <th style={{ border: "1px solid #dddddd", padding: "8px" }}>
              {" "}
              <Typography>SKU</Typography>
            </th>
            <th style={{ border: "1px solid #dddddd", padding: "8px" }}>
              {" "}
              <Typography>QTY</Typography>
            </th>
            <th style={{ border: "1px solid #dddddd", padding: "8px" }}>
              {" "}
              <Typography>Line Total</Typography>
            </th>
            <th style={{ border: "1px solid #dddddd", padding: "8px" }}>
              {" "}
              <Typography>Commission(%)</Typography>
            </th>

            <th style={{ border: "1px solid #dddddd", padding: "8px" }}>
              {" "}
              <Typography>Commission</Typography>
            </th>
          </tr>
          {data?.items?.map((item) => (
            <tr>
              <td style={{ border: "1px solid #dddddd", padding: "8px" }}>
                {" "}
                <Typography>{item?.item?.sku}</Typography>
              </td>
              <td style={{ border: "1px solid #dddddd", padding: "8px" }}>
                {" "}
                <Typography>{item?.item?.delivered_qty}</Typography>
              </td>
              <td style={{ border: "1px solid #dddddd", padding: "8px" }}>
                {" "}
                <Typography>${item?.item?.line_price}</Typography>
              </td>
              <td style={{ border: "1px solid #dddddd", padding: "8px" }}>
                {" "}
                <Typography>{item?.percentage}%</Typography>
              </td>
              <td style={{ border: "1px solid #dddddd", padding: "8px" }}>
                {" "}
                <Typography>${item?.value}</Typography>
              </td>
            </tr>
          ))}
        </table>

        <Typography variant="h5" sx={{ pt: 2 }}>
          {" "}
          Total: ${data?.value}
        </Typography>
      </DialogContent>
    </Dialog>
  );
}
